import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import goalLostImg from 'assets/images/goal_lost_img.png';
import { PATHS } from 'config/paths';
import { withLocale } from '@dietlabs/components';
import Layout from 'Layout/Layout';

class GoalLost extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        renderTimeline: PropTypes.func,
    };

    static defaultProps = {
        renderTimeline: undefined,
    };

    render() {
        return (
            <Layout page="diet">
                {this.props.renderTimeline && this.props.renderTimeline('top')}
                <section className="my-5">
                    <Container>
                        <Row>
                            <Col
                                xs="12"
                                md={{ size: 6, offset: 3 }}
                                className="text-center"
                            >
                                <img
                                    className="mb-4 img-fluid"
                                    src={goalLostImg}
                                    role="presentation"
                                    alt=""
                                />
                                <h1 className="title-medium semi-bold">
                                    {this.props.t('info-pages/goal-lost/title')}
                                </h1>
                                <p>
                                    {this.props.t(
                                        'info-pages/goal-lost/content'
                                    )}
                                </p>
                                <Button
                                    color="primary"
                                    tag={Link}
                                    className="w-100"
                                    to={PATHS.MAKE_DECISION}
                                >
                                    {this.props.t(
                                        'info-pages/goal-lost/button'
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        );
    }
}

export { GoalLost };
export default withLocale(GoalLost);
